
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { addLineCollection } from "@insite/client-framework/Services/CartService";
import { getOrder } from "@insite/client-framework/Services/OrderService";
import siteMessage from "@insite/client-framework/SiteMessage";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    CartLineCollectionModel,
    CartLineModel,
    OrderModel,
} from "@insite/client-framework/Types/ApiModels";

export interface ReorderResult {
    order: OrderModel;
    cartLines?: CartLineCollectionModel;
}

type CustomReorderParameter = {
    orderNumber: string;
    onSuccess?: (result: ReorderResult | undefined) => void;
    onError?: (message: string) => void;
};

type HandlerType = ApiHandlerDiscreteParameter<
    CustomReorderParameter,
    CartLineCollectionModel,
    ReorderResult | undefined
>;

export const DispatchBeginReorder: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });

    props.dispatch({
        type: "Pages/OrderHistory/BeginReorder",
        orderNumber: props.parameter.orderNumber,
    });
};

export const FetchOrderWithLines: HandlerType = async props => {
    const order = await getOrder({
        orderNumber: props.parameter.orderNumber,
        expand: ["orderLines"],
    });

    props.apiResult = { order };
};

export const PopulateApiParameter: HandlerType = props => {
    if (!props.apiResult?.order.orderLines?.some(o => !!o.productId)) {
        props.apiResult = undefined;

        props.dispatch({
            type: "Pages/OrderHistory/CompleteReorder",
            orderNumber: props.parameter.orderNumber,
        });

        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });

        props.parameter.onError?.(
            siteMessage("OrderHistory_NoProductsAvailableForReorder") as string,
        );

        return false;
    }

    props.apiParameter = {
        cartLines: props.apiResult.order.orderLines.map(
            line =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                }) as CartLineModel,
        ),
    } as CartLineCollectionModel;
};

export const SendDataToApi: HandlerType = async props => {
    if (!props.apiResult) {
        return;
    }

    props.apiResult.cartLines = await addLineCollection({
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: props.apiParameter,
    });
};

export const ExecuteOnSuccessCallbackCustom: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteReorder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/CompleteReorder",
        orderNumber: props.parameter.orderNumber,
    });

    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const chain = [
    DispatchBeginReorder,
    FetchOrderWithLines,
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnSuccessCallbackCustom,
    LoadCart,
    DispatchCompleteReorder,
];

const reorderCustom = createHandlerChainRunner(chain, "RorderCustom");

export default reorderCustom;
// import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
// import {
//     ApiHandlerDiscreteParameter,
//     createHandlerChainRunnerOptionalParameter,
//     HasOnSuccess,
// } from "@insite/client-framework/HandlerCreator";
// import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
// import { addLineCollection } from "@insite/client-framework/Services/CartService";
// import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
// import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
// import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

// type ReorderParameter = HasOnSuccess<CartLineCollectionModel> & {
//     orderNumber: string;
//     onError?: (message: string) => void;
//     onComplete?: (resultProps: {
//         apiResult?: CartLineCollectionModel;
//     }) => void;
// };

// type HandlerType = ApiHandlerDiscreteParameter<
//     ReorderParameter,
//     CartLineCollectionModel,
//     CartLineCollectionModel
// >;

// export const DispatchBeginReorder: HandlerType = props => {
//     throwErrorIfTesting();

//     props.dispatch({
//         type: "Context/BeginUpdatingCart",
//     });
//     props.dispatch({
//         type: "Pages/OrderDetails/BeginReorder",
//     });
// };

// export const PopulateApiParameter: HandlerType = props => {
//     const state = props.getState();
//     const order = getOrderState(state, state.pages.orderDetails.orderNumber);
//     if (!order.value) {
//         throw new Error("Reorder was called but there was no order available");
//     }

//     props.apiParameter = {
//         cartLines: order.value.orderLines!.map(
//             (line: OrderLineModel) =>
//                 ({
//                     productId: line.productId,
//                     qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
//                     unitOfMeasure: line.unitOfMeasure,
//                 } as CartLineModel),
//         ),
//     } as CartLineCollectionModel;
// };

// export const SendDataToApi: HandlerType = async props => {
//     props.apiResult = await addLineCollection({
//         cartId: API_URL_CURRENT_FRAGMENT,
//         cartLineCollection: props.apiParameter,
//     });
// };

// export const DispatchCompleteReorder: HandlerType = props => {
//     props.dispatch({
//         type: "Pages/OrderDetails/CompleteReorder",
//         cartLineCollection: props.apiResult,
//     });
//     props.dispatch({
//         type: "Context/CompleteUpdatingCart",
//     });
// };

// export const ExecuteOnSuccessCallback: HandlerType = props => {
//     props.parameter.onSuccess?.(props.apiResult);
// };

// export const LoadCart: HandlerType = props => {
//     props.dispatch(loadCurrentCart());
// };

// export const chain = [
//     DispatchBeginReorder,
//     PopulateApiParameter,
//     SendDataToApi,
//     DispatchCompleteReorder,
//     ExecuteOnSuccessCallback,
//     LoadCart,
// ];

// const reorderCustom = createHandlerChainRunnerOptionalParameter(chain,{},  "reorderCustom");
// export default reorderCustom;

